import React, { useState } from "react";
import { Card, Typography, Table, Pagination, Popconfirm, message } from "antd";
import { useParams } from "react-router-dom";
import { DeleteTwoTone } from "@ant-design/icons";
import { capitalizeWords } from "../../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import AddLocationModal from "./AddLocationModal";
import EditableImage from "../../../../components/icons/EditIcon";

const { Title } = Typography;

// NOTE: This component is a placeholder for the Location tab.
// The API for fetching location data is not yet available.
// When the API is ready, we need to:
// 1. Fetch data using the organization ID.
// 2. Populate the table with actual location data.
// 3. Implement add/edit/delete functionality.

const Location = (props) => {
    const { id } = useParams();
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [loadAgain, setLoadAgain] = useState(false);
    const [editingLocation, setEditingLocation] = useState(null);

    const [searchText, setSearchText] = useState("");

    const {
        data,
        loading,
    } = useCommonListing({
        passSize: 1000,
        passPage: 1,
        passURL: `/customer/locationlist/?organization_id=${id}`,
        includeStatus: true,
        loadAgain: loadAgain,
    });

    const handleLocalSearch = (e) => {
        setSearchText(e.target.value);
    };

    const filteredData = data?.filter((item) => {
        if (!searchText) return true;
        const search = searchText.toLowerCase();
        return (
            item.location_name?.toLowerCase().includes(search) ||
            item.address_1?.toLowerCase().includes(search) ||
            item.city?.toLowerCase().includes(search) ||
            item.state?.toLowerCase().includes(search) ||
            item.zip_code?.toLowerCase().includes(search) ||
            (item.country || "United States").toLowerCase().includes(search)
        );
    });

    const handleDelete = (record) => {
        // TODO: Implement delete API call
        console.log("Delete location:", record);
        message.info("Delete functionality to be implemented");
    };

    const handleEdit = (record) => {
        setEditingLocation(record);
        setIsAddModalOpen(true);
    };

    // TODO: Define actual columns based on API response
    const columns = [
        {
            title: "Location Name",
            dataIndex: "location_name",
            key: "location_name",
            width: 200,
        },
        {
            title: "Address",
            dataIndex: "address_1",
            key: "address_1",
            width: 200,
        },
        {
            title: "City",
            dataIndex: "city",
            key: "city",
            width: 150,
        },
        {
            title: "State",
            dataIndex: "state",
            key: "state",
            width: 100,
        },
        {
            title: "Zip/Postal Code",
            dataIndex: "zip_code",
            key: "zip_code",
            width: 150,
            render: (text) => (text ? text : "-"),
        },
        {
            title: "Country",
            dataIndex: "country",
            key: "country",
            width: 100,
            render: (text) => (text ? text : "-"),
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            width: 100,
            align: "center",
            fixed: "right",
            render: (_, record) => (
                <div style={{ display: "flex", fontSize: "1.9rem", marginLeft: "0.7rem", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                    <EditableImage
                        handleRowClick={() => handleEdit(record)}
                        recordId={record.id}
                        disabled={!canEdit}
                    />
                    <Popconfirm
                        title="Are you sure you want to delete this location?"
                        // onConfirm={() => handleDelete(record)}
                        okText="Yes"
                        cancelText="No"
                        disabled={!canEdit}
                    >
                        {/* <DeleteTwoTone
                            twoToneColor="#eb2f96"
                            style={{ fontSize: "1.9rem", cursor: canEdit ? "pointer" : "not-allowed", opacity: canEdit ? 1 : 0.5 }}
                        /> */}
                    </Popconfirm>
                </div>
            ),
        }
    ];

    // const { canEdit } = props;
    // Using a default value for now since we don't have functional constraints yet
    const canEdit = true;



    return (
        <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
            <Title level={5} style={{ marginInline: "10px" }}>
                Location
            </Title>
            <CommonTopDetails
                title="Location List"
                titleSuffix={`${filteredData?.length || 0} item(s)`}
                searchPlaceholder="Search..."
                searchAction={handleLocalSearch}
                showAddButton={true}
                addButtonProps={{
                    title: "Add Location",
                    modalType: "PopUP",
                    modalProps: () => setIsAddModalOpen(true),
                    disabled: !canEdit,
                }}
                filterAction={false}
                marginPass="15px"
                paddingInlinepass="10px"
            />

            <Table
                columns={columns}
                dataSource={filteredData}
                rowKey="id"
                size="small"
                loading={loading}
                className="table-container"
                style={{ margin: "1rem" }}
                pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: ["10", "20", "50"] }}
                bordered
                scroll={{ x: 1000 }}
            />


            {isAddModalOpen && (
                <AddLocationModal
                    open={isAddModalOpen}
                    onCancel={() => {
                        setIsAddModalOpen(false);
                        setEditingLocation(null);
                    }}
                    organizationId={id}
                    onSuccess={() => setLoadAgain(!loadAgain)}
                    initialData={editingLocation}
                    isEdit={!!editingLocation}
                />
            )}
        </Card>
    );
};

export default Location;
 